var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f0e9xs23aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v1295H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zf0737y27b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.927 5.934-.195 3.843-.012.062a.244.244 0 0 1-.245.16.274.274 0 0 1-.17-.07l-1.84-1.5-1.782 1.506-.055.036a.26.26 0 0 1-.297-.047.217.217 0 0 1-.069-.164l-.194-3.826a3.947 3.947 0 0 0 2.43.832c.734 0 1.45-.2 2.064-.575.126-.082.252-.164.365-.257zM1.024.954c1.368-1.272 3.584-1.272 4.953 0C6.605 1.545 7 2.366 7 3.268c0 2.601-3.114 4.148-5.424 2.724C-.264 4.862-.552 2.43 1.024.954zm2.68.316c-.106-.147-.307-.135-.395-.012l-.76.985-1.224.363c-.176.047-.226.228-.132.345l.766.979-.006 1.195c-.006.176.163.275.314.229l1.23-.375 1.224.369c.17.058.327-.059.327-.205L5.04 3.93l.754-.967c.119-.135.044-.305-.107-.351l-1.237-.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yrc46zkbkc",
    x1: 8.483,
    y1: 5,
    x2: 0,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0e9xs23aa)",
    transform: "translate(-955 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zf0737y27b)",
    transform: "translate(955 116)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#yrc46zkbkc)",
    d: "M0 0h7v10H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.e1a7a42d79251ad4f8558a0e7a6e65f0.svg";
export { ForwardRef as ReactComponent };